import {
    CHAIN_INFO,
    ChainInfo,
    EnabledChains,
    SupportedChains,
} from '../config/constants';
import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletLinkConnector } from '@web3-react/walletlink-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { NetworkConnector } from './NetworkConnector';
import { config } from '../config/config';

export const RPC_URLS: Record<
    EnabledChains[number],
    ChainInfo[EnabledChains[number]]['rpcUrls'][number]
> = {
    [SupportedChains.ARBITRUM_ONE]: CHAIN_INFO[SupportedChains.ARBITRUM_ONE].rpcUrls[0],
};

export const networkConnector = new NetworkConnector({
    urls: {
        [SupportedChains.ARBITRUM_ONE]: RPC_URLS[SupportedChains.ARBITRUM_ONE],
    },
    defaultChainId: SupportedChains.ARBITRUM_ONE,
});

export const injected = new InjectedConnector({
    supportedChainIds: config.enabledChains as number[],
});

export const walletConnect = new WalletConnectConnector({
    rpc: {
        [SupportedChains.ARBITRUM_ONE]: RPC_URLS[SupportedChains.ARBITRUM_ONE],
    },
    bridge: 'https://bridge.walletconnect.org',
    qrcode: true,
    chainId: SupportedChains.ARBITRUM_ONE,
    supportedChainIds: [SupportedChains.ARBITRUM_ONE],
});

export const walletlink = new WalletLinkConnector({
    url: RPC_URLS[SupportedChains.ARBITRUM_ONE],
    appName: 'Unlimited Leverage',
    supportedChainIds: [SupportedChains.ARBITRUM_ONE],
});
